import { api, app } from '../../app'
import { Mock, underscore as under, util as MUtil } from '../../util/mockUtil'

const FalseData = false

const getParams = () => {
    return {
        indexno: app.getData('indexno'),
        account: app.getData('account'),
    }
}

/**
 * 获取报备首页数据
 * @returns {Promise<*>}
 */
export const getHomeData = async () => {
    const { flag, data, msg } = await app.post(api.TTaskHome, getParams())
    if (flag === 1) {
        return data
    } else {
        app.alert(msg, 'error', '45%')
        return {}
    }
}

/**
 * 获取报备角色列表
 * @param id
 * @returns {Promise<*>}
 */
export const getRoleList = async (id) => {
    const params = getParams()
    if (id) {
        params.task_team_id = id
    }
    const { flag, data, msg } = await app.post(api.TRoleLists, params)
    if (flag === 1) {
        return data
    } else {
        app.alert(msg, 'error', '45%')
        return []
    }
}

/**
 * 新请求列表
 * @returns {Promise<*>}
 */
export const getRequestList = async () => {
    if (FalseData) {
        const data = under.range(MUtil.num(1, 20)).map(t => {
            return {
                task_id: t,
                name: Mock.mock('@cname'),
                response_flag: '1',
                response_flag_title: '未应答',
                created_at: Mock.mock('@datetime()'),
                task_type: MUtil.num(1, 3),
                type: MUtil.num(1, 3)
            }
        })
        return {
            total: data.length,
            data: data
        }
    }
    const { flag, data, msg, total } = await app.post(api.TRequestLists, getParams())
    if (flag === 1) {
        return { data, total }
    } else {
        app.alert(msg, 'error', '45%')
        return { data: [], total: 0 }
    }
}

/**
 * 请求详情
 * @param param
 * @param param.id
 * @param param.task_type 报备类型（1一般报备；2省；3国）
 * @param param.type 响应类型（1队员响应；2队长响应；3督导官响应）
 * @returns {Promise<any.data>}
 */
export const getRequestDetail = async (param) => {
    if (FalseData) {
        await app.sleep()
        return {
            task_id: '1',
            task_type: MUtil.num(1, 3),
            type: MUtil.num(1, 3),
            title: Mock.mock('@ctitle'),
            union_team: ['测试队伍1'],
            address: Mock.mock('@county(true)'),
            collect_place: Mock.mock('@county(true)'),
            date: Mock.mock('@datetime()'),
            collect_date: Mock.mock('@datetime()'),
            teamno: '测0002',
            teamname: '测试队伍2',
            ppe_volunteer: under.range(MUtil.num(1, 10)).map(p => {
                return {
                    name: Mock.mock('@cname'),
                    indexno: `测000${p}`,
                    ppe_name: Mock.mock('@title(6)'),
                }
            }),
            volunteer: under.range(MUtil.num(1, 10)).map(p => {
                return {
                    name: Mock.mock('@cname'),
                    indexno: `测000${p}`,
                    ppe_name: Mock.mock('@title(6)'),
                }
            }),
            lead: {
                name: Mock.mock('@cname'),
                indexno: `测00001`,
                ppe_name: Mock.mock('@title(6)'),
            },
            clerk: {
                name: Mock.mock('@cname'),
                indexno: `测00002`,
                ppe_name: Mock.mock('@title(6)'),
            }
        }
    }
    const { flag, data, msg } = await app.post(api.TRequestDetail, Object.assign(param, getParams()))
    if (flag === 1) {
        return data
    } else {
        app.alert(msg, 'error', '45%')
        throw msg
    }
}


/**
 * 请求响应
 * @param param
 * @param param.id
 * @param param.task_type 报备类型（1一般报备；2省；3国）
 * @param param.type 响应类型（1队员响应；2队长响应；3督导官响应）
 * @param param.flag 1应答；2拒绝
 * @param param.message 拒绝理由
 * @param param.img 保险图片路径
 * @param zd_msg 自定信息
 * @returns {Promise<boolean>}
 */
export const requestResponse = async (param, zd_msg) => {
    if (FalseData) {
        await app.sleep()
        return true
    }
    const { flag, msg } = await app.post(api.TRequestEdit, Object.assign(param, getParams()))
    if (flag === 1) {
        !zd_msg && app.alert(msg, 'success', '45%')
        return true
    } else {
        app.alert(msg, 'error', '45%')
        return false
    }
}


/**
 * 队员正在进行中任务列表
 * @param page 页数
 * @returns {Promise<{data: any.data, total: any.total}>}
 */
export const getExecuteList = async (page) => {
    if (FalseData) {
        const data = under.range(MUtil.num(1, 20)).map(t => {
            return {
                task_id: t,
                task_team_id: t,
                name: Mock.mock('@ctitle'),
                created_at: Mock.mock('@datetime()'),
                created_by: '测0001',
                task_type: MUtil.num(1, 3),
                process_type: MUtil.arrayRadom([0, 3]),
                process_name: Mock.mock('@ctitle(4)')
            }
        })
        return {
            total: data.length,
            data: data
        }
    }
    let params = getParams()
    params.page = page
    const { flag, data, msg, total } = await app.post(api.TExecuteLists, params)
    if (flag === 1) {
        return { data, total }
    } else {
        app.alert(msg, 'error', '45%')
        throw msg
    }
}


/**
 * 管辖正在进行中任务列表
 * @param page 页数
 * @returns {Promise<{data: any.data, total: any.total}>}
 */
export const getTaskList = async (page) => {
    if (FalseData) {
        const data = under.range(MUtil.num(1, 20)).map(t => {
            let flag = MUtil.arrayRadom([1, 2, 10, 13])
            const fts = [{ name: '报备中', id: 1 }, { name: '报备完毕', id: 2 }, { name: '任务完成', id: 10 }, {
                name: '取消',
                id: 13
            }]
            let flag_title = fts.filter(f => f.id === flag)[0]
            return {
                task_id: t,
                task_team_id: t,
                name: Mock.mock('@ctitle'),
                flag: flag,
                flag_title: flag_title,
                created_at: Mock.mock('@datetime()'),
                created_by: '测0001',
                task_type: MUtil.num(1, 3)
            }
        })
        return {
            total: data.length,
            data: data
        }
    }
    let params = getParams()
    params.page = page
    const { flag, data, msg, total } = await app.post(api.TTaskLists, params)
    if (flag === 1) {
        return { data, total }
    } else {
        app.alert(msg, 'error', '45%')
        throw msg
    }
}


/**
 * 历史任务列表
 * @param page 页数
 * @returns {Promise<{data: any.data, total: any.total}>}
 */
export const getLogList = async (page) => {
    if (FalseData) {
        const data = under.range(MUtil.num(1, 20)).map(t => {
            let flag = MUtil.arrayRadom([1, 2, 10, 13])
            const fts = [{ name: '报备中', id: 1 }, { name: '报备完毕', id: 2 }, { name: '任务完成', id: 10 }, {
                name: '取消',
                id: 13
            }]
            let flag_title = fts.filter(f => f.id === flag)[0]
            return {
                id: t,
                name: Mock.mock('@ctitle'),
                flag: flag,
                flag_title: flag_title,
                created_at: Mock.mock('@datetime()'),
                task_type: MUtil.num(1, 3)
            }
        })
        return {
            total: data.length,
            data: data
        }
    }
    let params = getParams()
    params.page = page
    const { flag, data, msg, total } = await app.post(api.TLogLists, params)
    if (flag === 1) {
        return { data, total }
    } else {
        app.alert(msg, 'error', '45%')
        throw msg
    }
}


/**
 * 发布报备队伍选择列表
 * @returns {Promise<any.data>}
 */
export const getTeamSelectList = async () => {
    const { flag, data, msg } = await app.post(api.TTeamSelectLists, getParams())
    if (flag === 1) {
        return data
    } else {
        app.alert(msg, 'error', '45%')
        throw msg
    }
}


/**
 * 添加一般报备
 * @param param
 * @returns {Promise<*>}
 */
export const addCommonTask = async (param) => {
    if (FalseData) {
        await app.sleep()
        return { task_id: '1', task_team_id: '1' }
    }
    const { flag, data, msg } = await app.post(api.CTAdd, Object.assign(param, getParams()))
    if (flag === 1) {
        return data
    } else {
        app.alert(msg, 'error', '45%')
        return false
    }
}


/**
 * 报备池
 * @param param
 * @returns {Promise<*>}
 */
export const getCommonPool = async (param) => {
    if (FalseData) {
        await app.sleep()
        const test1 = (type, response_flag, count = 1) => {
            const types = ['队长', '普通队员', '技能人员', '文员']
            const response_flags = ['未响应', '应答', '拒绝']
            if (count > 1) {
                const datas = []
                for (let i = 0; i < count; i++) {
                    datas.push({
                        id: MUtil.num(1, 200),
                        name: Mock.mock('@cname'),
                        team: '测试队伍',
                        indexno: '测00001',
                        response_message: Mock.mock('@cparagraph(1, 4)'),
                        insure_img: Mock.Random.dataImage(),
                        type: type,
                        type_name: types[type - 1],
                        response_flag: response_flag,
                        response_flag_title: response_flags[response_flag - 1]
                    })
                }
                return datas
            } else {
                return {
                    id: MUtil.num(1, 200),
                    name: Mock.mock('@cname'),
                    team: '测试队伍',
                    indexno: '测00001',
                    response_message: Mock.mock('@cparagraph(1, 4)'),
                    insure_img: Mock.Random.dataImage(),
                    type: type,
                    type_name: types[type - 1],
                    response_flag: response_flag,
                    response_flag_title: response_flags[response_flag - 1]
                }
            }
        }
        const result = {
            task_id: param.task_id,
            task_team_id: param.task_team_id,
            lead: test1(1, 2),
            clerk: test1(1, 3),
            choose: test1(2, 2, MUtil.num(2, 20)),
            wait: test1(3, 1, MUtil.num(2, 20)),
            response: test1(2, 2, MUtil.num(2, 20)),
            refuse: test1(3, 3, MUtil.num(2, 20)),

        }
        console.log(result)
        return result
    }
    const { flag, data, msg } = await app.post(api.CTPool, Object.assign(param, getParams()))
    if (flag === 1) {
        return data
    } else {
        app.alert(msg, 'error', '45%')
        throw msg
    }
}


/**
 * 报备池选择队员
 * @param id
 * @returns {Promise<*>}
 */
export const commonPoolAdd = async (id) => {
    if (FalseData) {
        return true
    }
    const params = getParams()
    params.id = id
    const { flag, msg } = await app.post(api.CTPoolAdd, params)
    if (flag === 1) {
        return true
    } else {
        app.alert(msg, 'error', '45%')
        return false
    }
}


/**
 * 报备池取消选择队员
 * @param id
 * @returns {Promise<*>}
 */
export const commonPoolDel = async (id) => {
    if (FalseData) {
        return true
    }
    const params = getParams()
    params.id = id
    const { flag, msg } = await app.post(api.CTPoolDelete, params)
    if (flag === 1) {
        return true
    } else {
        app.alert(msg, 'error', '45%')
        return false
    }
}


/**
 * 报备池修改队长、文员
 * @param param
 * @returns {Promise<*>}
 */
export const commonPoolEdit = async (param) => {
    if (FalseData) {
        return true
    }
    const { flag, msg } = await app.post(api.CTPoolEdit, Object.assign(param, getParams()))
    if (flag === 1) {
        app.alert(msg, 'success', '45%')
        return true
    } else {
        app.alert(msg, 'error', '45%')
        return false
    }
}


/**
 * 提交报备池
 * @param id
 * @returns {Promise<*>}
 */
export const commonPoolSubmit = async (id) => {
    if (FalseData) {
        return true
    }
    const params = getParams()
    params.task_team_id = id
    const { flag, msg } = await app.post(api.CTPoolSubmit, params)
    if (flag === 1) {
        app.alert(msg, 'success', '45%')
        return true
    } else {
        app.alert(msg, 'error', '45%')
        return false
    }
}


/**
 * 一般报备 默认和选项
 * @returns {Promise<*>}
 */
export const commonOption = async () => {
    const { flag, data, msg } = await app.post(api.ReportsOption, getParams())
    if (flag === 1) {
        return data
    } else {
        app.alert(msg, 'error', '45%')
        return { service_subject: [], type: [] }
    }
}


/**
 * 管辖下的队伍列表
 * @returns {Promise<*>}
 */
export const getManageTeamAll = async () => {
    const { flag, data, msg } = await app.post(api.TTeamSelectLists, getParams())
    if (flag === 1) {
        return data
    } else {
        app.alert(msg, 'error', '45%')
        return []
    }
}


/**
 * 发布报备队长/文员选择列表
 * @param teamno
 * @returns {Promise<*>}
 */
export const getVolunteerSelectLists = async (teamno) => {
    const params = getParams()
    params.teamno = teamno
    const { flag, data, msg } = await app.post(api.TVolunteerSelectLists, params)
    if (flag === 1) {
        return data
    } else {
        app.alert(msg, 'error', '45%')
        return []
    }
}


/**
 * 技能人才选择列表
 * @param param
 * @returns {Promise<*>}
 */
export const getPpeSelectLists = async (param) => {
    const { flag, data, msg, total } = await app.post(api.TPpeSelectLists, Object.assign(param, getParams()))
    if (flag === 1) {
        return { data, total }
    } else {
        app.alert(msg, 'error', '45%')
        return { data: [], total: 0 }
    }
}


/**
 * 技能选择列表
 * @returns {Promise<*>}
 */
export const getPpeClassList = async () => {
    const { flag, data, msg } = await app.post(api.PpeClass, { parent: 1 })
    if (flag === 1) {
        return data
    } else {
        app.alert(msg, 'error', '45%')
        return []
    }
}


/**
 * 技能选择列表
 * @returns {Promise<*>}
 */
export const getProvince = async () => {
    const { flag, data, msg } = await app.post(api.ProvinceList)
    if (flag === 1) {
        return data
    } else {
        app.alert(msg, 'error', '45%')
        return []
    }
}


/**
 * 获取省下的队伍列表
 * @returns {Promise<*>}
 */
export const getTeamByProvince = async (province) => {
    const { flag, data, msg } = await app.post(api.ProvinceTeamList, { province })
    if (flag === 1) {
        return data
    } else {
        app.alert(msg, 'error', '45%')
        return []
    }
}

/**
 * 获取省以及区市
 * @returns {Promise<*>}
 */
export const getProvinceAndCitys = async () => {
    const { flag, data, msg } = await app.post(api.TProvinceCityLists, getParams())
    if (flag === 1) {
        return data
    } else {
        app.alert(msg, 'error', '45%')
        return []
    }
}

/**
 * 获取省以及区市下的队伍
 * @param param
 * @returns {Promise<*>}
 */
export const getTaskTeamLists = async (param) => {
    const { flag, data, msg, total } = await app.post(api.TTeamLists, Object.assign(param, getParams()))
    if (flag === 1) {
        return { data, total }
    } else {
        app.alert(msg, 'error', '45%')
        return { data: [], total: 0 }
    }
}

/**
 * 获取队内请求列表
 * @param params
 * @returns {Promise<*>}
 */
export const getTeamRequestList = async (params) => {
    if (FalseData) {
        await app.sleep()
        const flags = ['未响应', '答应', '拒绝']
        return {
            data: under.range(MUtil.num(1, 20)).map(t => {
                let flag = MUtil.num(1, 3)
                return {
                    id: t,
                    title: Mock.mock('@ctitle(20)'),
                    content: Mock.mock('@ctitle(20)'),
                    created_at: Mock.mock('@datetime'),
                    response_date: Mock.mock('@datetime'),
                    response_flag: flag,
                    response_flag_title: flags[flag - 1],
                    response_message: Mock.mock('@ctitle(10)'),
                }
            }), total: 40
        }
    }
    const { flag, data, msg, total } = await app.post(api.CTTeamRequestLists, Object.assign(params, getParams()))
    if (flag === 1) {
        return { data, total }
    } else {
        app.alert(msg, 'error', '45%')
        return { data: [], total: 0 }
    }
}


/**
 * 添加队内请求
 * @param param
 * @returns {Promise<*>}
 */
export const teamRequestAdd = async (param) => {
    if (FalseData) {
        app.alert('提交成功', 'success', '45%')
        return true
    }
    const { flag, msg } = await app.post(api.CTTeamRequestAdd, Object.assign(param, getParams()))
    if (flag === 1) {
        app.alert(msg, 'success', '45%')
        return true
    } else {
        app.alert(msg, 'error', '45%')
        return false
    }
}


/**
 * 指挥官审核请求
 * @param param
 * @returns {Promise<*>}
 */
export const teamRequestAudit = async (param) => {
    if (FalseData) {
        await app.sleep()
        app.alert('审核成功', 'success', '45%')
        return true
    }
    const { flag, msg } = await app.post(api.CTTeamRequestAudit, Object.assign(param, getParams()))
    if (flag === 1) {
        app.alert(msg, 'success', '45%')
        return true
    } else {
        app.alert(msg, 'error', '45%')
        return false
    }
}

/**
 * 图文直播详细页
 * @param id
 * @returns {Promise<*>}
 */
export const getTeamLiveDetail = async (id) => {
    if (FalseData) {
        await app.sleep()
        return {
            title: Mock.mock('@ctitle(20)'),
            live: under.range(MUtil.num(1, 10)).map(l => {
                return {
                    created_at: Mock.mock('@datetime'),
                    created_by: Mock.mock('@cname'),
                    content: Mock.mock('@ctitle(30)'),
                    img: under.range(MUtil.num(1, 5)).map(m => Mock.mock('@image'))
                }
            })
        }
    }
    const params = getParams()
    params.task_team_id = id
    const { flag, data, msg } = await app.post(api.CTLiveDetail, params)
    if (flag === 1) {
        return data
    } else {
        app.alert(msg, 'error', '45%')
        return { title: '', live: [] }
    }
}


/**
 * 添加图文直播
 * @param param
 * @returns {Promise<*>}
 */
export const teamLiveAdd = async (param) => {
    if (FalseData) {
        await app.sleep()
        app.alert('添加成功', 'success')
        return true
    }
    const { flag, msg } = await app.post(api.CTLiveAdd, Object.assign(param, getParams()))
    if (flag === 1) {
        return true
    } else {
        app.alert(msg, 'error', '45%')
        return false
    }
}


/**
 * 调整报备详细页面
 * @param id
 * @returns {Promise<*>}
 */
export const trimDetail = async (id) => {
    if (FalseData) {
        await app.sleep()
        return {
            task_team_id: id,
            task_type: MUtil.num(1, 3),
            type: MUtil.num(1, 3),
            name: Mock.mock('@ctitle'),
            flag_title: Mock.mock('@ctitle(6)'),
            union_team: ['测试队伍1'],
            address: Mock.mock('@county(true)'),
            date: Mock.mock('@datetime()'),
            collect_place: Mock.mock('@county(true)'),
            collect_date: Mock.mock('@datetime()'),
            teamno: '测0002',
            teamname: '测试队伍2',
            ppe_volunteer: under.range(MUtil.num(1, 10)).map(p => {
                return {
                    name: Mock.mock('@cname'),
                    indexno: `测000${p}`,
                    ppe_name: Mock.mock('@title(6)'),
                }
            }),
            volunteer: under.range(MUtil.num(1, 10)).map(p => {
                return {
                    name: Mock.mock('@cname'),
                    indexno: `测000${p}`,
                    ppe_name: Mock.mock('@title(6)'),
                }
            }),
            lead: Mock.mock('@cname'),
            clerk: Mock.mock('@cname'),
            equip: under.range(MUtil.num(1, 10)).map(e => Mock.mock('@title(4)'))
        }
    }
    const params = getParams()
    params.task_team_id = id
    const { flag, data, msg } = await app.post(api.CTTrimDetail, params)
    if (flag === 1) {
        return data
    } else {
        app.alert(msg, 'error', '45%')
        return []
    }
}


/**
 * 调整报备 - 添加装备
 * @param param
 * @returns {Promise<*>}
 */
export const trimEquipAdd = async (param) => {
    if (FalseData) {
        await app.sleep()
        app.alert('添加成功', 'success', '45%')
        return true
    }
    const { flag, msg } = await app.post(api.CTTrimEquipAdd, Object.assign(param, getParams()))
    if (flag === 1) {
        app.alert(msg, 'success', '45%')
        return true
    } else {
        app.alert(msg, 'error', '45%')
        return false
    }
}


/**
 * 调整报备 - 技能人员选择列表
 * @param param
 * @returns {Promise<*>}
 */
export const getCTPpeSelectLists = async (param) => {
    if (FalseData) {
        await app.sleep()
        const data = under.range(MUtil.num(1, 100)).map((p) => {
            return {
                indexno: `测000${p}`,
                name: Mock.mock('@cname'),
                ppeid: p,
                ppe_name: Mock.mock('@title(6)'),
                teamname: '测试队伍1',
                is_send: Mock.mock('@boolean')
            }
        })
        return { data, total: data.length }
    }
    const { flag, data, total, msg } = await app.post(api.CTPpeSelectLists, Object.assign(param, getParams()))
    if (flag === 1) {
        return { data, total }
    } else {
        app.alert(msg, 'error', '45%')
        return { data: [], total: 0 }
    }
}


/**
 * 调整报备 - 队员选择列表
 * @param param
 * @returns {Promise<*>}
 */
export const volunteerSelectLists = async (param) => {
    if (FalseData) {
        await app.sleep()
        const flags = ['未响应', '应答', '拒绝']
        const data = under.range(MUtil.num(30, 100)).map((p) => {
            const flag = MUtil.num(1, 3)
            return {
                id: p,
                indexno: `测000${p}`,
                name: Mock.mock('@cname'),
                bsr: `蓝000${p}`,
                is_send: Mock.mock('@boolean'),
                response_flag: flag,
                response_flag_title: flags[flag - 1],
                response_message: Mock.mock('@ctitle(20)'),
                img: Mock.mock('@image')
            }
        })
        return data
    }
    const { flag, data, msg } = await app.post(api.CTVolunteerSelectLists, Object.assign(param, getParams()))
    if (flag === 1) {
        return data
    } else {
        app.alert(msg, 'error', '45%')
        return []
    }
}


/**
 * 调整报备 - 修改指挥官提交操作
 * @param params
 * @returns {Promise<*>}
 */
export const trimLeadSubmit = async (params) => {
    if (FalseData) {
        await app.sleep()
        app.alert('提交成功', 'success', '45%')
        return true
    }
    const { flag, msg } = await app.post(api.CTTrimLeadSubmit, Object.assign(params, getParams()))
    if (flag === 1) {
        app.alert(msg, 'success', '45%')
        return true
    } else {
        app.alert(msg, 'error', '45%')
        return false
    }
}


/**
 * 联合队伍提交报备
 * @param params
 * @returns {Promise<*>}
 */
export const unionAdd = async (params) => {
    if (FalseData) {
        await app.sleep()
        app.alert('提交成功', 'success', '45%')
        return true
    }
    const { flag, data, msg } = await app.post(api.CTUnionAdd, Object.assign(params, getParams()))
    if (flag === 1) {
        app.alert(msg, 'success', '45%')
        return data
    } else {
        app.alert(msg, 'error', '45%')
        return false
    }
}


/**
 * 调整报备 - 修改文员提交操作
 * @param params
 * @returns {Promise<*>}
 */
export const trimClerkSubmit = async (params) => {
    if (FalseData) {
        await app.sleep()
        app.alert('提交成功', 'success', '45%')
        return true
    }
    const { flag, msg } = await app.post(api.CTTrimClerkSubmit, Object.assign(params, getParams()))
    if (flag === 1) {
        app.alert(msg, 'success', '45%')
        return true
    } else {
        app.alert(msg, 'error', '45%')
        return false
    }
}


/**
 * 调整报备 - 取消修改
 * @param params
 * @returns {Promise<*>}
 */
export const trimCancel = async (params) => {
    if (FalseData) {
        await app.sleep()
        app.alert('取消成功', 'success', '45%')
        return true
    }
    const { flag, msg } = await app.post(api.CTTrimCancel, Object.assign(params, getParams()))
    if (flag === 1) {
        app.alert(msg, 'success', '45%')
        return true
    } else {
        app.alert(msg, 'error', '45%')
        return false
    }
}


/**
 * 调整报备 - 删除装备
 * @param param
 * @returns {Promise<*>}
 */
export const trimEquipDelete = async (param) => {
    if (FalseData) {
        await app.sleep()
        app.alert('删除成功', 'success', '45%')
        return true
    }
    const { flag, msg } = await app.post(api.CTTrimEquipDelete, Object.assign(param, getParams()))
    if (flag === 1) {
        app.alert(msg, 'success', '45%')
        return true
    } else {
        app.alert(msg, 'error', '45%')
        return false
    }
}


/**
 * 进程队伍选择列表
 * @param id
 * @returns {Promise<*>}
 */
export const getProcessTeamSelectLists = async (id) => {
    if (FalseData) {
        await app.sleep()
        return under.range(MUtil.num(1, 5)).map(t => {
            return {
                task_team_id: t,
                teamno: `测000${t}`,
                teamname: `测试队伍——${t}`
            }
        })
    }
    const params = getParams()
    params.task_id = id
    const { flag, data, msg } = await app.post(api.CTProcessTeamSelectLists, params)
    if (flag === 1) {
        return data
    } else {
        app.alert(msg, 'error', '45%')
        return []
    }
}


/**
 * 进程按钮
 * @param id
 * @returns {Promise<*>}
 */
export const getProcessBtnLists = async (id) => {
    if (FalseData) {
        await app.sleep()
        const types = ['报备完毕', '队员应答', '集合完毕任务成立', '到达现场', '开始一线任务', '中途离场', '中途反场', '收队', '完成任务', '调整报备', '请求协助', '取消任务']
        return under.range(MUtil.num(1, types.length + 1)).map(t => {
            return {
                value: t,
                name: types[t - 1]
            }
        })
    }
    const params = getParams()
    params.task_team_id = id
    const { flag, data, msg } = await app.post(api.CTProcessBtnLists, params)
    if (flag === 1) {
        return data
    } else {
        app.alert(msg, 'error', '45%')
        return []
    }
}


/**
 * 进程详情
 * @param param
 * @returns {Promise<*>}
 */
export const getProcessDetail = async (param) => {
    if (FalseData) {
        await app.sleep()
        const types = ['报备完毕', '队员应答', '集合完毕任务成立', '到达现场', '开始一线任务', '中途离场', '中途反场', '收队', '完成任务', '调整报备', '请求协助', '取消任务']
        return {
            task_id: param.task_id,
            task_team_id: param.task_team_id,
            task_type: MUtil.num(1, 3),
            task_name: Mock.mock('@cname'),
            union_team: ['测试队伍1'],
            address: Mock.mock('@county(true)'),
            collect_place: Mock.mock('@county(true)'),
            date: Mock.mock('@datetime()'),
            collect_date: Mock.mock('@datetime()'),
            teamno: '测0002',
            teamname: '测试队伍2',
            request_num: MUtil.num(0, 5),
            process: under.range(MUtil.num(0, 12)).map(n => {
                return {
                    title: types[n],
                    type: n,
                    date: Mock.mock('@datetime'),
                    count: Mock.mock('@ctitle(10)'),
                    content: under.range(MUtil.num(0, 4)).map(c => Mock.mock('@ctitle(10)')),
                }
            })
        }
    }
    const { flag, data, msg } = await app.post(api.CTProcessDetail, Object.assign(param, getParams()))
    if (flag === 1) {
        return data
    } else {
        app.alert(msg, 'error', '45%')
        return {}
    }
}


/**
 * 添加进程
 * @param param
 * @returns {Promise<*>}
 */
export const processAdd = async (param) => {
    if (FalseData) {
        await app.sleep()
        app.alert('添加成功', 'success', '45%')
        return true
    }
    const { flag, msg } = await app.post(api.CTProcessAdd, Object.assign(param, getParams()))
    if (flag === 1) {
        app.alert(msg, 'success', '45%')
        return true
    } else {
        app.alert(msg, 'error', '45%')
        return false
    }
}


/**
 * 调整报备-添加队员选择
 * @param param
 * @returns {Promise<*>}
 */
export const trimVolunteerAdd = async (param) => {
    if (FalseData) {
        await app.sleep()
        app.alert('添加成功', 'success', '45%')
        return true
    }
    const { flag, msg } = await app.post(api.CTTrimVolunteerAdd, Object.assign(param, getParams()))
    if (flag === 1) {
        app.alert(msg, 'success', '45%')
        return true
    } else {
        app.alert(msg, 'error', '45%')
        return false
    }
}


/**
 * 调整报备-删除队员选择
 * @param param
 * @returns {Promise<*>}
 */
export const trimVolunteerDelete = async (param) => {
    if (FalseData) {
        await app.sleep()
        app.alert('删除成功', 'success', '45%')
        return true
    }
    const { flag, msg } = await app.post(api.CTTrimVolunteerDelete, Object.assign(param, getParams()))
    if (flag === 1) {
        app.alert(msg, 'success', '45%')
        return true
    } else {
        app.alert(msg, 'error', '45%')
        return false
    }
}


/**
 * 调整报备-添加队员提交操作
 * @param param
 * @returns {Promise<*>}
 */
export const trimVolunteerSubmit = async (param) => {
    if (FalseData) {
        await app.sleep()
        app.alert('提交成功', 'success', '45%')
        return true
    }
    const { flag, msg } = await app.post(api.CTTrimVolunteerSubmit, Object.assign(param, getParams()))
    if (flag === 1) {
        app.alert(msg, 'success', '45%')
        return true
    } else {
        app.alert(msg, 'error', '45%')
        return false
    }
}


/**
 * 调整报备-添加技能队员页
 * @param id
 * @returns {Promise<*>}
 */
export const trimPpe = async (id) => {
    if (FalseData) {
        await app.sleep()
        return {
            task_team_id: id,
            response: under.range(MUtil.num(1, 10)).map(r => {
                return {
                    id: r,
                    name: Mock.mock('@cname'),
                    indexno: `测000${r}`,
                    bsr: `蓝000${r}`,
                    ppe_name: Mock.mock('@ctitle(5)'),
                    img: ''
                }
            }),
            choose: under.range(MUtil.num(1, 10)).map(r => {
                return {
                    id: r,
                    name: Mock.mock('@cname'),
                    indexno: `测000${r}`,
                    bsr: `蓝000${r}`,
                    ppe_name: Mock.mock('@ctitle(5)'),
                    img: ''
                }
            }),
        }
    }
    const params = getParams()
    params.task_team_id = id
    const { flag, data, msg } = await app.post(api.CTTrimPpe, params)
    if (flag === 1) {
        return data
    } else {
        app.alert(msg, 'error', '45%')
        return { response: [], choose: [] }
    }
}


/**
 * 调整报备-添加普通队员页
 * @param params
 * @returns {Promise<*>}
 */
export const trimVolunteer = async (params) => {
    if (FalseData) {
        await app.sleep()
        return {
            task_team_id: params.task_team_id,
            volunteer: under.range(MUtil.num(1, 10)).map(r => {
                return {
                    id: r,
                    name: Mock.mock('@cname'),
                    indexno: `测000${r}`,
                    bsr: `蓝000${r}`,
                    img: ''
                }
            }),
            response: under.range(MUtil.num(1, 10)).map(r => {
                return {
                    id: r,
                    name: Mock.mock('@cname'),
                    indexno: `测000${r}`,
                    bsr: `蓝000${r}`,
                    img: ''
                }
            }),
            choose: under.range(MUtil.num(1, 10)).map(r => {
                return {
                    id: r,
                    name: Mock.mock('@cname'),
                    indexno: `测000${r}`,
                    bsr: `蓝000${r}`,
                    img: ''
                }
            }),
        }
    }
    const { flag, data, msg } = await app.post(api.CTTrimVolunteer, Object.assign(params, getParams()))
    if (flag === 1) {
        return data
    } else {
        app.alert(msg, 'error', '45%')
        return { volunteer: [], response: [], choose: [] }
    }
}


/**
 * 调整报备-添加技能队员选择
 * @param param
 * @returns {Promise<*>}
 */
export const trimPpeAdd = async (param) => {
    if (FalseData) {
        await app.sleep()
        app.alert('添加成功', 'success', '45%')
        return true
    }
    const { flag, msg } = await app.post(api.CTTrimPpeAdd, Object.assign(param, getParams()))
    if (flag === 1) {
        app.alert(msg, 'success', '45%')
        return true
    } else {
        app.alert(msg, 'error', '45%')
        return false
    }
}


/**
 * 调整报备-删除技能队员选择
 * @param param
 * @returns {Promise<*>}
 */
export const trimPpeDelete = async (param) => {
    if (FalseData) {
        await app.sleep()
        app.alert('删除成功', 'success', '45%')
        return true
    }
    const { flag, msg } = await app.post(api.CTTrimPpeDelete, Object.assign(param, getParams()))
    if (flag === 1) {
        app.alert(msg, 'success', '45%')
        return true
    } else {
        app.alert(msg, 'error', '45%')
        return false
    }
}


/**
 * 调整报备-队员选择列表
 * @param param
 * @returns {Promise<*>}
 */
export const trimPpeSubmit = async (param) => {
    if (FalseData) {
        await app.sleep()
        app.alert('提交成功', 'success', '45%')
        return true
    }
    const { flag, msg } = await app.post(api.CTTrimPpeSubmit, Object.assign(param, getParams()))
    if (flag === 1) {
        app.alert(msg, 'success', '45%')
        return true
    } else {
        app.alert(msg, 'error', '45%')
        return false
    }
}


/**
 * 调整报备-发送通知
 * @param param
 * @param destroy
 * @returns {Promise<*>}
 */
export const sendRequest = async (param, destroy) => {
    if (FalseData) {
        await app.sleep()
        if (destroy) {
            app.alertDestroy()
        }
        app.alert('发送成功', 'success', '45%')
        return true
    }
    const { flag, msg } = await app.post(api.CTSendRequest, Object.assign(param, getParams()))
    if (destroy) {
        app.alertDestroy()
    }
    if (flag === 1) {
        app.alert(msg, 'success', '45%')
        return true
    } else {
        app.alert(msg, 'error', '45%')
        return false
    }
}


/**
 * 重新发送请求，拒绝列表
 * @param param
 * @returns {Promise<*>}
 */
export const poolResends = async (param) => {
    if (FalseData) {
        await app.sleep()
        app.alert('发送成功', 'success', '45%')
        return true
    }
    const { flag, msg } = await app.post(api.CTPoolResends, Object.assign(param, getParams()))
    if (flag === 1) {
        app.alert(msg, 'success', '45%')
        return true
    } else {
        app.alert(msg, 'error', '45%')
        return false
    }
}


/**
 * 重新发送请求，队长，文员
 * @param param
 * @returns {Promise<*>}
 */
export const poolResend = async (param) => {
    if (FalseData) {
        await app.sleep()
        app.alert('发送成功', 'success', '45%')
        return true
    }
    const { flag, msg } = await app.post(api.CTPoolResend, Object.assign(param, getParams()))
    if (flag === 1) {
        app.alert(msg, 'success', '45%')
        return true
    } else {
        app.alert(msg, 'error', '45%')
        return false
    }
}






// WEBPACK FOOTER //
// ./src/routes/report/task_api.jsx